import { render } from "./LabelCropsModal.vue?vue&type=template&id=ef7874b0"
import script from "./LabelCropsModal.vue?vue&type=script&lang=js"
export * from "./LabelCropsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__